<h1 mat-dialog-title>{{ data.title || 'Error' }}</h1>
<div mat-dialog-content>
  <p [innerHTML]="data.message"></p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true">OK</button>
</div>
